import { DienstleistungsModule } from './dienstleistungsmodule.enum';

export class DienstleistungsModuleBeschreibung {
    public id: number;
    public dienstleistungsmodule: DienstleistungsModule;
    public title: string;
    public lastChanged: string;
}
